import React, { useEffect } from 'react';

function MicroFrontend({
  name,
  host,
  history,
  privileges,
  componentProps,
  containerId,
}) {
  // const host = 'http://localhost:3001';
  const commonName = 'CommonModule';
  useEffect(() => {
    const scriptId = `micro-frontend-script-${commonName}`;

    const renderMicroFrontend = () => {
      if (document.getElementById(containerId)) {
        if (typeof window.renderCommonModule !== 'undefined') {
          window.renderCommonModule(
            containerId,
            history,
            privileges,
            componentProps
          );
        }
      }
    };

    if (document.getElementById(scriptId)) {
      renderMicroFrontend();
      return;
    }

    fetch(`${host}/asset-manifest.json`)
      .then((res) => res.json())
      .then((manifest) => {
        const script = document.createElement('script');
        script.id = scriptId;
        script.crossOrigin = '';
        script.src = `${host}${manifest.files['main.js']}`;
        const link = document.createElement('link');
        link.id = `micro-frontend-link-${commonName}`;
        link.crossOrigin = '';
        link.rel = 'stylesheet';
        link.href = `${host}${manifest.files['main.css']}`;
        script.onload = () => {
          renderMicroFrontend();
        };
        document.head.appendChild(script);
        document.head.appendChild(link);
      });

    return () => {
      window[`unmount${commonName}`] &&
        window[`unmount${commonName}`](containerId);
    };
  });

  return <main id={containerId} />;
}

MicroFrontend.defaultProps = {
  document,
  window,
};

export default MicroFrontend;
